export default __webpack_public_path__ + "static/media/2.b41e8636.png";